import Button from '~/components/Buttons/Button'
import { ButtonProps } from '~/components/Buttons/types'

/** Outlined action on the landing cards — `ButtonSecondary`'s purple ring reads as a second primary. */
export default function SchoolOutlineButton({ children, className, ...rest }: ButtonProps): React.ReactElement {
  return (
    <Button className={`ring-2 ring-school-night text-school-night focus:ring-4 ${className ?? ''}`} {...rest}>
      {children}
    </Button>
  )
}
